const Charges = {

    // FIELDS
    "premise": "Premise",
    "cycle_type": "Type",
    "cyclic": "Cyclick",
    "non_cyclic": "Non Cyclick",
    "type": "Charge Type",
    "pricing_type": "Pricing Type",
    "amount": "Value",
    "sqft": "Sqft",
    "per_unit": "Per Unit",
    "percentage": "%",

    // PAGE HEADER
    "charges": "Charges",

    // ERROR
    "error_premise": "Select Premise",
    "error_cycle_type": "Select Type",
    "error_type": "Select Charge Type",
    "error_pricing_type": "Select Pricing Type",
    "error_amount": "Enter Value",
    "error_negative": "Amount cannot be negative",

}

export default Charges;